/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
    CriteriaCategoryToJSONTyped,
} from './CriteriaCategory';

/**
 * 
 * @export
 * @interface BulkUpdateCriteriaCategoriesRequest
 */
export interface BulkUpdateCriteriaCategoriesRequest {
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    categories: Array<CriteriaCategory>;
}

/**
 * Check if a given object implements the BulkUpdateCriteriaCategoriesRequest interface.
 */
export function instanceOfBulkUpdateCriteriaCategoriesRequest(value: object): value is BulkUpdateCriteriaCategoriesRequest {
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function BulkUpdateCriteriaCategoriesRequestFromJSON(json: any): BulkUpdateCriteriaCategoriesRequest {
    return BulkUpdateCriteriaCategoriesRequestFromJSONTyped(json, false);
}

export function BulkUpdateCriteriaCategoriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateCriteriaCategoriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'categories': ((json['categories'] as Array<any>).map(CriteriaCategoryFromJSON)),
    };
}

export function BulkUpdateCriteriaCategoriesRequestToJSON(json: any): BulkUpdateCriteriaCategoriesRequest {
    return BulkUpdateCriteriaCategoriesRequestToJSONTyped(json, false);
}

export function BulkUpdateCriteriaCategoriesRequestToJSONTyped(value?: BulkUpdateCriteriaCategoriesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'categories': ((value['categories'] as Array<any>).map(CriteriaCategoryToJSON)),
    };
}

